import { useSyncExternalStore } from "react";

import isStandaloneDisplay, { subscribeStandaloneDisplay } from "~/pwa/isStandaloneDisplay";

const getServerSnapshot = (): boolean => false;

const useIsStandaloneDisplay = (): boolean =>
	useSyncExternalStore(subscribeStandaloneDisplay, isStandaloneDisplay, getServerSnapshot);

export default useIsStandaloneDisplay;
